export default __webpack_public_path__ + "static/spetgroup-1f5d7735073a75ca882c974f83144af4.gif";